import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';
import { useRouterStore } from 'apps/hooks';

import Icon from 'components/Icon';
import { Date } from 'apps/components/date';

import useOutisdeClick from './useOutsideClick';

import {
  DropdownInitialWrapper,
  DropdownContentWrapper,
  RowWrapper,
  RowTitleWrapper,
  RowDescriptionWrapper,
} from './dropdown.styled';

function Dropdown(props) {
  const { revisionsConnection, selectedRevision } = props;
  const routerStore = useRouterStore();
  const { ref, isOpen, setOpen } = useOutisdeClick(false);

  const { route } = routerStore;

  const options = revisionsConnection.arrayApp.apps.map(obj => (
    <Link
      key={obj.id}
      name={route.name}
      params={{ ...route.params, v: obj.version }}
    >
      <RowWrapper
        selected={selectedRevision?.id === obj.id}
        onClick={() => {
          setOpen(false);
        }}
      >
        <RowTitleWrapper>{obj.title}</RowTitleWrapper>
        <RowDescriptionWrapper>
          <Trans>
            <Date value={obj.dateCreated} /> by {obj.creator.username}
          </Trans>
        </RowDescriptionWrapper>
      </RowWrapper>
    </Link>
  ));

  return (
    <div ref={ref}>
      <DropdownInitialWrapper onClick={() => setOpen(!isOpen)}>
        <RowTitleWrapper>{selectedRevision?.title}</RowTitleWrapper>
        <Icon name={isOpen ? 'caret_up' : 'caret_down'} size='small' />
      </DropdownInitialWrapper>
      {isOpen && <DropdownContentWrapper>{options}</DropdownContentWrapper>}
    </div>
  );
}

Dropdown.propTypes = {
  revisionsConnection: PropTypes.object,
  selectedRevision: PropTypes.object,
};

export default withNamespaces()(Dropdown);
